import { CLUSTER, IS_DEVELOP_FEATURE } from '@/shared/config';

import { TRANSCRIPTOR_LANGUAGE } from '@/entities/transcriptor';

import {
  RecordingMethod,
  RecordingMode,
  TranscriptorPreferences,
  TreatmentProcessingMode,
} from './types';

export const TRANSCRIPTOR_PREFERENCES_KEY = 'transcriptorRecordingPreferences';

export const TREATMENT_PROCESSING_MODES: TreatmentProcessingMode[] = [
  'liveFill',
  'upload',
];

export const DEFAULT_RECORDING_MODE: RecordingMode = 'visit';

// The live mode each recording mode records with; the organization's choice
// is stored as it too.
export const RECORDING_MODE_LIVE_MODE: Record<
  RecordingMode,
  TreatmentProcessingMode
> = {
  visit: 'upload',
  dictation: 'liveFill',
};

// Audio kept while a live connection opens or reopens: 1500 frames of about
// 43 ms each hold about one minute.
export const LIVE_AUDIO_QUEUE_LIMIT = 1500;

// Time the transcription provider has for the last phrase after Stop.
export const LIVE_TRANSCRIPT_FINISH_TIMEOUT_MS = 5000;

// Scribe bounds one accepted fill to 300 s; 15 s more for its answer to arrive.
export const LIVE_FINAL_FILL_TIMEOUT_MS = 315_000;

// A final fill that failed may still have been applied: its stored answers are
// read once, for at most this long.
export const LIVE_FINAL_ANSWERS_READ_TIMEOUT_MS = 10_000;

export const DEFAULT_TRANSCRIPTOR_LANGUAGE =
  CLUSTER === 'ru' || IS_DEVELOP_FEATURE
    ? TRANSCRIPTOR_LANGUAGE.Russian
    : TRANSCRIPTOR_LANGUAGE.English;

export const DEFAULT_TRANSCRIPTOR_PREFERENCES: TranscriptorPreferences = {
  schemaId: '',
  templateSeriesIds: [],
  recordingMethod: RecordingMethod.Record,
  language: DEFAULT_TRANSCRIPTOR_LANGUAGE,
};
